import ViewBase from '../../view-base.view';
import '../../../utils/extensions.js'
import CVProjectsListView from './projects/custom-vision.projects-list.view';
import CVTrainingImagesListView from './training-images/custom-vision.training-images-list.view';


export default function CustomVisionOverviewView() {
    ViewBase.call(this);

    let isShowingProjectsPage = true;
    let isShowingTrainingImagesPage = false;

    let selectedProjectId = 0;
    let selectedProjectName = '';

    let _showProjectsPage = () => {
        isShowingProjectsPage = true;
        isShowingTrainingImagesPage = false;
        selectedProjectId = 0;
        selectedProjectName = '';
    }

    let _showTrainingPhotosPage = (projectId, projectName) => {
        isShowingProjectsPage = false;
        isShowingTrainingImagesPage = true;
        selectedProjectId = projectId;
        selectedProjectName = projectName;
    }

    return {
        view: (vnode) => {
            return [
                m('.row', 
                    
                    isShowingProjectsPage && m(CVProjectsListView, {
                        showTrainingPhotosPage: _showTrainingPhotosPage
                    }),
                    isShowingTrainingImagesPage && m(CVTrainingImagesListView, { 
                        projectId: selectedProjectId,
                        projectName: selectedProjectName,
                        showProjectsPage: _showProjectsPage
                    }),
                ), 
                this.getBaseViews()
            ];
        }
    }
}
